module.exports = __webpack_public_path__ + "static/media/img28.a300dac9.jpeg";